import { Component, h, JSX } from '@stencil/core';
import { HostElement, Element, State, Prop, Host } from '@stencil/core/internal';

@Component({
    tag: 'web-visibility-trigger',
    styleUrl: 'visibility-trigger.scss',
    shadow: true
})
export class VisibilityTrigger {
    @Element() hostElement: HostElement;

    /**
     * Whether the element is intersecting with the target element.
     */
    @State() intersecting = true;

    /**
     * The id of the target element to observe.
     */
    @Prop() targetElementId = 'trigger-element';

    /**
     * The threshold to trigger the visibility.
     */
    @Prop() threshold? = 0;

    private observer: IntersectionObserver;
    private targetElement: HTMLElement;

    componentDidRender(): void {
        this.targetElement = document.querySelector(`#${this.targetElementId}`);
        if (this.targetElement) {
            this.observer = new IntersectionObserver((elements) => (this.intersecting = elements[0].isIntersecting), {
                threshold: this.threshold
            });
            this.observer.observe(this.targetElement);
        }
    }

    disconnectedCallback(): void {
        this.observer.unobserve(this.targetElement);
    }

    public render(): JSX.Element {
        const { intersecting } = this;

        return (
            <Host class={`trigger--${intersecting ? 'hidden' : 'visible'}`} hidden={intersecting}>
                <slot />
            </Host>
        );
    }
}
